import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/authSlice';

const useIdleTimeout = (timeout = 15 * 60 * 1000) => {
  const dispatch = useDispatch();
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      dispatch(logout());
    }, timeout);
  };

  useEffect(() => {
    resetTimer();
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keydown', resetTimer);
    };
  }, [dispatch, timeout]);

  return resetTimer;
};

export default useIdleTimeout;
